import React from 'react';

const CreateSurvey = () => {
  return (
    <div>
      <h2>Create Survey Page</h2>
      {/* Add your survey builder UI here */}
    </div>
  );
};

export default CreateSurvey;
